import isFunction from 'lodash/isFunction';
import isNil from 'lodash/isNil';

function requireFunctionIfFlagExists(flagName: string) {
    if (isNil(flagName)) {
        throw new Error('No flagName provided');
    }
    return (props, propName, componentName) => {
        if (
            props?.hasOwnProperty(flagName) &&
            props[flagName] === true &&
            (props[propName] === undefined || !isFunction(props[propName]))
        ) {
            return new Error(`Please provide a onClose function to ${componentName}`);
        }
    };
}

export default requireFunctionIfFlagExists;
